import axios from "axios"

export default function() {
    return { 
        insurances: [],

        insurance: null,

        init() {
            this.insurances = [];

            const back_button = document.querySelector('.btn-back');
            if (back_button) {
                back_button.addEventListener('click', () => {
                    this.insurance = null;
                });
            }

            this.$watch(() => this.insurance, (value) => {
                if (value) {
                    this.$refs.nextButton.click();
                } else {
                    console.log('No matching Other animal/Horseinsurance found for the selected item.');
                }
            });

            window.addEventListener('message', ({ data }) => {
                if (data) {
                    console.log('INSURELY EVENT:', data.name);

                    if (data.name === 'RESULTS') {
                        this.insurances = data.value;
                        console.log('Insurely insurances:', this.insurances);

                        if (data.value.length === 1) {
                            const insurance = this.insurances.find((item) => {
                                return item.insurance.insuranceType === 'animalInsurance' &&
                                    ['otherAnimalInsurance', 'horseInsurance'].includes(item.insurance.insuranceSubType);
                            });

                            this.insurance = insurance;
                        }
                    } else if (data.name === 'RESULTS_SELECTED_ITEM') {
                        console.log('Selected item from Insurely:', data.value.id);

                        const insurance = this.insurances.find((item) => {
                            return item.id === data.value.id &&
                                item.insurance.insuranceType === 'animalInsurance' &&
                                ['otherAnimalInsurance', 'horseInsurance'].includes(item.insurance.insuranceSubType);
                        });

                        this.insurance = insurance;
                    }
                }
            });
        }
    }
}